module.exports = __webpack_public_path__ + "ve.89aac662.svg";